import React from 'react'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import { SquareButton } from 'ui/buttons'
import { FieldWrapper, useField } from '@morningtrain/react-fields'

function PinField (props) {
  const [isHidden, setIsHidden] = React.useState(true)

  const inputType = () => {
    return isHidden ? 'password' : 'number'
  }

  const {
    id,
    name,
    value,
    onChange,
    wrap
  } = useField(props)

  const generatePin = (payload) => {
    onChange(payload.responses.generate_pin)
  }

  return wrap(() => (
    <>
      <div className='flex inner-field-wrapper'>
        <input id={id} name={name} type={inputType()} value={value} inputMode='numeric' pattern='[0-9]*' />
        <Pipeline>
          <TriggerPipelineOnClick>
            <SquareButton big color='btn-lightgray' className='ml-2'>
              <Icons.Refresh className='w-3 h-3' />
            </SquareButton>
          </TriggerPipelineOnClick>
          <ExecuteOperationOnPipe operationName='generate_pin' resourceName='users.profile' />
          <CallbackOnPipe callback={generatePin} />
        </Pipeline>
        <SquareButton big color='btn-lightgray' className='ml-2' onClick={() => setIsHidden(!isHidden)}>
          <Icons.Eye className='w-4 h-4' />
        </SquareButton>
      </div>
    </>
  ))
}

PinField.defaultProps = {
  ...useField.defaultProps,
  name: 'pin',
  label: <Translation name='fields.pin.label' />
}

PinField.propTypes = {
  ...useField.propTypes
}

export default PinField
